// extracted by mini-css-extract-plugin
export default {"root":"EmptyMessage-root-8936ac34fcda4ec6e81c9231f497b669"};